export default __webpack_public_path__ + "static/media/Punto_Benvenuto_ITA_Def.d588fd17.aac";